import {Button} from '@/components/ui/button/Button'
import {Flexbox} from '@/components/ui/flexbox/FlexBox'
import {AlertCircleIcon} from '@/components/ui/icon/Icon'
import {Text} from '@/components/ui/text/Text'
import {StyledProjectWarningMissingBanner} from '@/features/projects/components/project-warning-missing-banner/style'
import {ProjectExtended} from '@/features/projects/types'
import {Trans, useTranslation} from '@/translations/i18n'
import dayjs from 'dayjs'
import {useOutletContext, generatePath} from 'react-router-dom'
import {routes} from '@/utilities/constants/routes'
import {usePermissions} from '@/features/auth/store/store'

export const ProjectWarningMissingEvaluationEvent = () => {
    const {t} = useTranslation()
    const {project} = useOutletContext<{project: ProjectExtended}>()
    const permissions = usePermissions()

    const handleNavigateToAgenda = () => {
        // Always open the patient's agenda so the user can add the missing event there
        const agendaPath = generatePath(routes.AGENDA.path, {
            entity: 'patients',
            view: 'week',
            date: dayjs(project.startDate).format('DD-MM-YYYY')
        })

        const searchParams = new URLSearchParams({
            category: 'custom'
        })
        searchParams.append('subjectIds', project.patientId)

        window.open(`${agendaPath}?${searchParams.toString()}`, '_blank')
    }

    return (
        <StyledProjectWarningMissingBanner align="center">
            <Flexbox gap={1} align="center">
                <AlertCircleIcon />
                <Text palette="neutral" shade="950" size="textSm">
                    <Trans
                        i18nKey="projects:missing_event_content"
                        components={{b: <b />}}
                        values={{
                            event: t('agenda:access_initial_project_evaluation')
                        }}
                    />
                </Text>
            </Flexbox>
            {permissions?.agenda.read && permissions?.agenda.write && (
                <Button variant="tertiary" onClick={handleNavigateToAgenda}>
                    {t('commons:add')}
                </Button>
            )}
        </StyledProjectWarningMissingBanner>
    )
}
